
import { Component, Prop, Vue } from "vue-property-decorator";
import type { CreateElement } from "vue";
import { VChip } from "vuetify/lib";
import type { FeedingScheduleItemAllocation } from "@gigalot/data-models";

@Component
export default class FeedScheduleRations extends Vue {
  @Prop({ default: () => [] }) allocations!: FeedingScheduleItemAllocation[];
  @Prop({ default: "" }) ration!: string;
  @Prop({ default: "black" }) colour!: string;
  @Prop({ default: false }) blend!: boolean;
  @Prop({ default: () => ({}) }) rationColours!: Record<string, string>;

  render(h: CreateElement) {
    if (!this.blend || !this.allocations.length) return h(VChip, { props: { color: this.colour } }, [h("strong", this.ration)]);
    return h(
      "div",
      { class: "feed-schedule-rations" },
      this.allocations.map((allocation, index) => {
        const current = Boolean(allocation.active || allocation.allocated);
        return h(
          VChip,
          {
            key: index,
            class: { "feed-schedule-ration-session": true, "feed-schedule-ration-session--current": current },
            props: { small: true, color: this.rationColours[allocation.rationGuid] || this.rationColours[allocation.ration] || this.colour },
            attrs: {
              "aria-current": current ? "step" : undefined,
              title: `Session ${index + 1}${current ? " (Current)" : ""}${allocation.allocated ? " — Job assigned to vehicle" : ""}`,
            },
          },
          [
            ...(current ? [h("span", { class: "mr-1", attrs: { "aria-hidden": "true" } }, "▶")] : []),
            h(current ? "strong" : "span", `S${index + 1}: ${allocation.ration || this.ration}`),
          ]
        );
      })
    );
  }
}
